import {
  FETCH_LOGIN,
  FETCH_LOGIN_SUCCESS,
  FETCH_LOGIN_FAILURE,
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
} from './constants';

import Api from '../../services/api';
import { errorAlert } from '../../containers/App/actions';

export const requestLogin = () => ({
  type: FETCH_LOGIN,
});

export const requestLoginFailure = payload => ({
  type: FETCH_LOGIN_FAILURE,
  payload,
});

export const requestLoginSuccess = payload => ({
  type: FETCH_LOGIN_SUCCESS,
  payload,
});

export const requestUser = () => ({
  type: FETCH_USER,
});

export const requestUserFailure = payload => ({
  type: FETCH_USER_FAILURE,
  payload,
});

export const requestUserSuccess = payload => ({
  type: FETCH_USER_SUCCESS,
  payload,
});

export const getMe = () => {
  return dispatch => {
    dispatch(requestUser());
    Api.getLoggedUser()
      .then(res => {
        dispatch(requestUserSuccess(res.user));
      })
      .catch(error => {
        dispatch(requestUserFailure(error));
      });
  };
};

export const login = (email, password) => {
  return async dispatch => {
    dispatch(requestLogin(email, password));
    const res = await Api.getLogin(email, password);
    if (res.status === 'ERROR') {
      dispatch(errorAlert(res.message[0]));
      dispatch(requestLoginFailure(res.message));
      throw new Error(res.message[0]);
    } else {
      dispatch(requestLoginSuccess(res));
      await dispatch(getMe());
    }
  };
};



// WEBPACK FOOTER //
// ./src/containers/Login/actions.js